import { useState } from "react";

export const useUpdate = function () {
	const [value, setValue] = useState(0);
	return [
		value,
		() => setValue(value => value + 1),
	] as const;
}
